import { createContext } from "react";

const ActionModalContext = createContext();

export default ActionModalContext;
